import { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useFinancialStore } from './store/useFinancialStore'
import { ThemeProvider } from './components/ThemeProvider'
import Navigation from './components/Navigation'
import Footer from './components/Footer'
import { ARIAProvider } from './contexts/ARIAContext'
import { VoiceAgentProvider } from './contexts/VoiceAgentContext'
import ARIAFloatingButton from './components/ARIAFloatingButton'
import ARIACommandTerminal from './components/ARIACommandTerminal'
import ProtectedRoute from './components/ProtectedRoute'
import FloatingAvatar from './components/FloatingAvatar'

// Import pages
import HomePage from './pages/HomePage'
import DashboardPage from './pages/DashboardPage'
import PortfolioPage from './pages/PortfolioPage'
import TradingPage from './pages/TradingPage'
import MarketWatchPage from './pages/MarketWatchPage'
import AssistantPage from './pages/AssistantPage'
import ImageAnalysisPage from './pages/ImageAnalysisPage'
import AdvancedAnalysisPage from './pages/AdvancedAnalysisPage'
import AdvancedIndicatorsPage from './pages/AdvancedIndicatorsPage'
import AISignalsPage from './pages/AISignalsPage'
import TradingAgentsPage from './pages/TradingAgentsPage'
import ProfilePage from './pages/ProfilePage'
import AuthLoginPage from './pages/AuthLoginPage'
import AuthRegisterPage from './pages/AuthRegisterPage'
import APITestPage from './pages/APITestPage'
import GlassDemoPage from './glass-demo/page'

function App() {
  const { refreshDashboard, connectWebSocket } = useFinancialStore();

  useEffect(() => {
    // Sovereign Core Ignition
    refreshDashboard();
    connectWebSocket();
  }, [refreshDashboard, connectWebSocket]);

  return (
    <ThemeProvider defaultTheme="dark" storageKey="richguru-theme">
      <VoiceAgentProvider>
        <ARIAProvider>
          <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true
            }}
          >
          <div className="min-h-screen text-white selection:bg-brand-teal/30">
            <Navigation />
            <main className="container-landing py-8">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/dashboard" element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                } />
                <Route path="/portfolio" element={
                  <ProtectedRoute>
                    <PortfolioPage />
                  </ProtectedRoute>
                } />
                <Route path="/trading" element={
                  <ProtectedRoute>
                    <TradingPage />
                  </ProtectedRoute>
                } />
                <Route path="/market-watch" element={<MarketWatchPage />} />
                <Route path="/assistant" element={
                  <ProtectedRoute>
                    <AssistantPage />
                  </ProtectedRoute>
                } />
                <Route path="/image-analysis" element={<ImageAnalysisPage />} />
                <Route path="/advanced-analysis" element={<AdvancedAnalysisPage />} />
                <Route path="/advanced-indicators" element={<AdvancedIndicatorsPage />} />
                <Route path="/ai-signals" element={
                  <ProtectedRoute>
                    <AISignalsPage />
                  </ProtectedRoute>
                } />
                <Route path="/a2a" element={
                  <ProtectedRoute>
                    <TradingAgentsPage />
                  </ProtectedRoute>
                } />
                <Route path="/profile" element={
                  <ProtectedRoute>
                    <ProfilePage />
                  </ProtectedRoute>
                } />
                <Route path="/auth/login" element={<AuthLoginPage />} />
                <Route path="/auth/register" element={<AuthRegisterPage />} />
                <Route path="/api-test" element={<APITestPage />} />
                <Route path="/glass-demo" element={<GlassDemoPage />} />
              </Routes>
            </main>
            <Footer />
            <ARIACommandTerminal />
            <FloatingAvatar />
            <ARIAFloatingButton />
          </div>
          </Router>
        </ARIAProvider>
      </VoiceAgentProvider>
    </ThemeProvider>
  )
}

export default App
